import React from "react";
import styled from "styled-components";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "@vitalsource/vstui";
import { primaryShade } from "../../../../common/ui/Styles";
import { useBrand } from "../../../../common/providers/brand/brand-context";

const BrowserNotSupportedGraphic = (props) => {
  const baseId = "A85C2FE7-98D7-F2A8-2679-A4CD74EB02F3";
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 791 326"
      style={{ maxWidth: "791px" }}
      {...props}
    >
      <defs>
        <path id={`${baseId}a`} d="M0 .522h300.312V266.51H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          strokeOpacity={0.6}
          stroke="#B0E3F4"
          strokeWidth={4}
          strokeLinecap="square"
          d="M2.5 260.5h786"
        />
        <g transform="translate(245 -.522)">
          <mask id={`${baseId}b`} fill="#fff">
            <use xlinkHref={`#${baseId}a`} />
          </mask>
          <path
            d="M290.433.522H9.878C4.422.522 0 4.945 0 10.4v211.489c0 5.456 4.423 9.878 9.88 9.878h123.124v20.282h-13.12c-1.02 0-1.847.827-1.847 1.847v10.768c0 1.02.826 1.846 1.846 1.846h60.547a1.846 1.846 0 0 0 1.847-1.846v-10.768c0-1.02-.826-1.847-1.847-1.847h-13.12v-20.282h123.124c5.456 0 9.88-4.422 9.88-9.878V10.399c0-5.454-4.424-9.877-9.88-9.877"
            fill="#B3B3B3"
            mask={`url(#${baseId}b)`}
          />
        </g>
        <path
          d="M527.64 209.257H262.671a2.47 2.47 0 0 1-2.469-2.47V14.578a2.47 2.47 0 0 1 2.47-2.468H527.64a2.47 2.47 0 0 1 2.47 2.469v192.209a2.47 2.47 0 0 1-2.47 2.47"
          fill="#FFF"
        />
        <path
          d="M527.64 209.257H262.671a2.47 2.47 0 0 1-2.469-2.47V14.578a2.47 2.47 0 0 1 2.47-2.468H527.64a2.47 2.47 0 0 1 2.47 2.469v192.209a2.47 2.47 0 0 1-2.47 2.47Z"
          stroke="#949494"
          strokeWidth={3.201}
        />
        <path
          stroke="#DADADA"
          strokeWidth={1.959}
          d="M528.604 186.198 264.975 13.377M265.658 13.103l103.867 195.296M279.571 39.364s-4.209-2.558-10.025-1.683c-6.246.939-10.325 4.826-10.325 4.826M286.353 52.16s-8.49-4.183-15.629-3.052c-5.832.924-11.503 6.298-11.503 6.298M293.377 65.228s-11.004-3.454-18.015-2.579c-7.286.91-16.054 7.201-16.054 7.201M300.317 78.505s-13.28-3.888-22.455-2.743c-9.534 1.19-18.425 9.505-18.425 9.505M306.931 90.502s-8.64-3.744-21.467-1.84c-13.774 2.045-24.676 16.26-24.676 16.26M319.072 112.694s-16.009-3.669-31.25-.776c-15.127 2.87-26.968 17.572-26.968 17.572M304.042 39.364s-6.797 0-11.92 3.699c-3.97 2.867-5.768 9.098-5.768 9.098"
        />
        <path
          d="M317.054 47.977s-10.294 1.01-15.458 4.246c-6.13 3.843-8.22 13.005-8.22 13.005M332.062 56.293s-13.324 1.568-20.659 6.167c-7.622 4.778-11.086 16.045-11.086 16.045M349.034 68.783s-17.298-.558-26.896 5.458c-9.974 6.253-13.428 20.098-13.428 20.098M370.931 83.495s-19.635 1.384-31.258 9.084c-12.08 8.003-18.014 25.155-18.014 25.155M385.526 92.644s-18.858 1.695-34.246 13.585c-12.885 9.956-20.644 29.479-20.644 29.479M399.96 11.696s-19.851 10.617-28.6 30.186c-7.323 16.384-2.14 40.292-2.14 40.292M434.95 11.937s-30.176 13.198-41.08 35.41c-9.13 18.6-8.344 45.297-8.344 45.297M308.646 13.632s-6.472 5.501-8.234 11.39c-1.512 5.051-1.484 10.999-1.484 10.999M331.329 11.937s-11.914 7.387-14.274 17.782c-1.662 7.314-1.31 18.259-1.31 18.259"
          stroke="#DADADA"
          strokeWidth={1.959}
        />
        <path
          d="M351.28 11.937s-15.659 8.185-19.218 20.688c-3.208 11.275 0 25.06 0 25.06M369.582 11.799s-18.083 13.195-21.835 24.322c-3.898 11.563 1.287 32.662 1.287 32.662"
          stroke="#DADADA"
          strokeWidth={1.959}
        />
        <path
          d="M527.64 209.257H262.671a2.47 2.47 0 0 1-2.469-2.47V14.578a2.47 2.47 0 0 1 2.47-2.468H527.64a2.47 2.47 0 0 1 2.47 2.469v192.209a2.47 2.47 0 0 1-2.47 2.47Z"
          stroke="#949494"
          strokeWidth={3.201}
        />
        <path stroke="#DADADA" strokeWidth={1.959} d="M300.418 78.84v214.749" />
        <path
          stroke="#F58525"
          strokeWidth={1.557}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m292.789 297.382-8.948-2.23-8.818 5.877"
        />
        <path
          stroke="#F58525"
          strokeWidth={1.557}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m292.236 301.056-5.744-2.43-16.926 9.655M292.56 304.471l-6.819-.637-4.416 14.143"
        />
        <path
          stroke="#F58525"
          strokeWidth={1.557}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m294.336 308.35-7.225.286 2.585 16.064M308.486 297.382l8.948-4.308 10.894 7.954M309.039 301.056l5.744-2.43 14.85 8.617"
        />
        <path
          stroke="#F58525"
          strokeWidth={1.557}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m308.715 304.471 6.819-1.675 6.493 14.143M306.94 308.35l6.186 1.324-2.585 13.987"
        />
        <path
          d="M310.897 302.165c0 5.62-4.589 10.175-10.25 10.175-5.663 0-10.253-4.555-10.253-10.175 0-5.62 4.59-10.174 10.252-10.174 5.662 0 10.251 4.555 10.251 10.174"
          fill="#E06107"
        />
        <path
          d="M309.255 307.366c0 4.03-3.854 7.297-8.608 7.297-4.755 0-8.61-3.267-8.61-7.297 0-4.03 3.855-7.298 8.61-7.298 4.754 0 8.608 3.268 8.608 7.298"
          fill="#B0430C"
        />
        <path
          d="M299.938 307.773a2.944 2.944 0 1 1-5.888 0 2.944 2.944 0 0 1 5.888 0"
          fill="#FFF"
        />
        <path
          d="M299.236 308.092a1.508 1.508 0 1 1-3.017 0 1.508 1.508 0 0 1 3.017 0"
          fill="#3C3C3C"
        />
        <path
          d="M301.354 307.773a2.944 2.944 0 1 0 5.888 0 2.944 2.944 0 0 0-5.888 0"
          fill="#FFF"
        />
        <path
          d="M302.056 308.092a1.508 1.508 0 1 0 3.017 0 1.508 1.508 0 0 0-3.017 0"
          fill="#3C3C3C"
        />
      </g>
    </svg>
  );
};

const Styled = {
  Container: styled.div`
    background-color: white;
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: auto;
  `,
  Content: styled.div`
    text-align: center;
    margin: 100px 20px 50px 20px;
  `,
  Title: styled.div`
    font-size: 4rem;
    color: ${primaryShade(6)};
    margin: 20px 0;
  `,
  Note: styled.div`
    display: inline-block;
    max-width: 492px;
    font-size: 1.6rem;
    margin-bottom: 40px;
  `,
  Controls: styled.div`
    font-size: 1.6rem;
    text-align: center;
    a {
      margin: 8px 16px;
    }
  `,
};

const PageErrorBrowserNotSupported: React.FC = () => {
  const intl = useIntl();
  const brand = useBrand();
  const browsersHref = intl.formatMessage({
    id: "errors.browserNotSupported.browserSupport.url",
  });
  const appHref = intl.formatMessage({
    id: "errors.browserNotSupported.appDownload.url",
  });
  const supportEnabled = brand.getProp<boolean>("Support.enabled");
  const downloadEnabled = brand.getProp<boolean>("DownloadOffline.enabled");

  return (
    <Styled.Container>
      <Styled.Content>
        <BrowserNotSupportedGraphic />
        <Styled.Title>
          <FormattedMessage id="errors.browserNotSupported.title" />
        </Styled.Title>
        <Styled.Note>
          <FormattedMessage id="errors.browserNotSupported.note" />
        </Styled.Note>
        {(supportEnabled || downloadEnabled) && (
          <Styled.Controls>
            {supportEnabled && (
              <Button href={browsersHref} target={"_blank"}>
                <FormattedMessage id="errors.browserNotSupported.viewBrowsers" />
              </Button>
            )}
            {downloadEnabled && (
              <Button outline={supportEnabled} href={appHref} target={"_blank"}>
                <FormattedMessage id="errors.browserNotSupported.getApp" />
              </Button>
            )}
          </Styled.Controls>
        )}
      </Styled.Content>
    </Styled.Container>
  );
};

export default PageErrorBrowserNotSupported;
